import { Component, OnInit } from '@angular/core';
import { GuiFlowService } from '../../../___LOGIC/__gui/gui-flow.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ConfigService } from 'src/app/___LOGIC/__config/config.service';
import { SecurityLayerService } from 'src/app/___LOGIC/__auth/security-layer.service';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})
export class LoginPageComponent implements OnInit {

  testing = environment.testingMode;
  hide = true;
  loading = false;

  signin = this.fb.group({
    username: ['sebas', [Validators.required]],
    password: [this.testing ? '1234' : '', [Validators.required, Validators.minLength(3)]],
    remember: [false]
  });

  get username() { return this.signin.get('username'); }
  get password() { return this.signin.get('password'); }

  constructor(private route: ActivatedRoute,private securityLayer: SecurityLayerService,private guiFLow: GuiFlowService,private configService: ConfigService,private fb: FormBuilder) { }

  ngOnInit(): void {
    if(this.securityLayer.checkForCookies('dashboard')){
      this.cookieLogin();
    }
  }

  onKeyUp(event: KeyboardEvent){
    if (event.key && event.key === "Enter") {
      this.login();
    }
  }

  login(){
    this.loading = true;
    const { username, password, remember } = this.signin.value as any;
    //this.securityLayer.saveLoginObj(loginObj);
    this.securityLayer.tryLogin({ username, password, remember });
  }

  cookieLogin(){
    let loginObj = {
      path: 'login',
      username: this.securityLayer.getCookie('voyjaleasSessionUsername'),
      token: this.securityLayer.getCookie('voyjaleasSessionToken')
    };
    this.securityLayer.saveLoginObj(loginObj);
    this.securityLayer.tryLogin(loginObj);
  }

  isLoading(){
    return this.securityLayer.isLoading();
  }

  async submit(): Promise<void> {
    /* if (this.form.invalid || this.loading) {
      this.form.markAllAsTouched();
      return;
    }
    this.loading = true; */

    try {
      /* const { email, password, remember } = this.form.value as any; */

      // Login to the CRM dashboard using X-Client header
      /* await this.auth.login({ email, password, remember }, 'dashboard'); */

      /* this.snack.open('¡Bienvenido! Redirigiendo…', 'OK', { duration: 1800 }); */
      // Change to your actual route after login
      /* this.router.navigateByUrl('/dashboard'); */
    } catch (err) {
      /* const msg = err?.error?.message || 'No fue posible iniciar sesión.';
      this.snack.open(msg, 'Cerrar', { duration: 3500 }); */
    } finally {
      /* this.loading = false; */
    }
  }

/*   getTranslation(t){
    return this.guiFLow.getTranslatedText(t);
  } */

/*   isFormFilled(){
    return this.usernameInput.value.length>0 && this.passwordInput.value.length>0;
  } */

}
